import React, { useEffect, useState } from 'react';
import { Box, Button, FormControl, Grid, MenuItem, Select, Typography, InputLabel } from '@mui/material'
import { ClassNameMap, withStyles } from '@mui/styles'
import stylesheet from '../detail-container.stylesheet'
import RejectRestrictDecisionComponent from './reject-restrict-decision.component';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { toast } from 'react-toastify';
import moment from 'moment';
import Helper from '../../../../utils/helper';
import ConfirmationDialogComponent from '../common/confirmation-dialog.component';

interface IProps {
	item: any
	stageActions: any
	outerSubmit: any
	outer: any
	compKey: string
	classes: ClassNameMap
}

const NextStageComponent: React.FC<IProps> = ({
	item,
	stageActions,
	outerSubmit,
	outer,
	compKey,
	classes,
}) => {
	const [status, setStatus] = useState(item.stage_approval_status);
	const [actionList, setActionList] = useState(stageActions || []);
	const [approveOpen, setApproveOpen] = useState(false)
	const [isMedOld, setIsMedOld] = useState(false)
	const [totalHr, setTotalHr] = useState() as any;
	const multiProgramConfirm = useSelector((state: RootState) => state.multiProgramConfirm)

	useEffect(() => {
		setIsMedOld(false)
		setStatus(item.stage_approval_status)
		handleConfirmClose()
	}, [item.lastEvalDate])

	const approveMed = (param: any) => {
		outerSubmit('stage_approval_status', param)
		outer('med_restriction')
		outer('med_action')
	}

	const handleConfirmClose = () => {
		setApproveOpen(false)
		setTotalHr('')
	}

	const confirmStatus = () => {
		approveMed('Approved')
		handleConfirmClose()
	}

	const onBtnClick = (_param: string) => {
		setStatus(_param)
		let isApproved = false
		if (item.lastEvalDate === null) {
			toast.warning("Evaluation date is not available. Please reset & generate care plan.", Helper.bottom_center())
			setIsMedOld(true)
			return
		}
		else if (item?.lastEvalDate !== null) {
			let startDate = moment.unix(item.lastEvalDate).format('YYYY-MM-DD HH:mm:ss')
			let endDate = moment().format('YYYY-MM-DD HH:mm:ss')
			let diff_milliseconds = Date.parse(endDate) - Date.parse(startDate);

			const seconds = ((diff_milliseconds) / 1000);
			const minutes = (seconds / 60);
			const hours = (minutes / 60);

			if (hours <= 4)
				isApproved = true
			else if (hours > 4 && hours <= 24) {
				setTotalHr(Math.floor(hours))
				setApproveOpen(true)
			}
			else {
				setIsMedOld(true)
				toast.warning("Evaluation is older than 24 hrs. Please run program evaluation.", Helper.bottom_center())
			}
		}

		if (isApproved)
			(_param === 'Approved') ? approveMed(_param) : outerSubmit('stage_approval_status', _param)
	}

	const handleActionChange = (e: any) => {
		if (e?.target?.value) {
			outerSubmit('med_action', e.target.value)
		}
	}

	const onBackClick = () => {
		setStatus(undefined)
		outer('med_restriction')
		outer('approval_status')
		outer(compKey)
	}

	const checkStageCount = (multiProgramConfirm: any) => ['med_evaluation', 'early_tox_check'].includes(item.stage)
	//&& (multiProgramConfirm.find((m: any) => m.program === item.program)?.pending <= 1)


	return (
		<>
			{status === 'Restrict' &&
				<Box pl={2}>
					<RejectRestrictDecisionComponent
						item={item}
						outerSubmit={outerSubmit}
						outer={onBackClick}
						handleClose={{}}
						handleSubmit={{}}
						compKey={compKey}
						parentComp=''
					/>
				</Box>
			}
			<Box p={2} className={status === 'Restrict' ? classes.displayNone : classes.subModalBackground}>
				<Grid container spacing={1} alignItems={"anchor-center"}>
					<Grid item >
						<Typography variant="h6" color="textSecondary">
							<Button variant="outlined"
								className={status === 'Approved' && !isMedOld
									? classes.dialogBtnActionSelected : classes.dialogBtnAction
								}
								size="small"
								disabled={isMedOld}
								onClick={() => onBtnClick('Approved')}
								sx={status === 'Approved' && !isMedOld ? {
									backgroundColor: 'var(--color-btn-selected-bg) !important',
									color: 'var(--color-btn-selected-text) !important',
									borderColor: 'var(--color-btn-selected-border) !important',
								} : undefined}
							>
								Approve
							</Button>
						</Typography>
					</Grid>
					<Grid item>
						<Button
							variant="outlined"
							size="small"
							disabled={!checkStageCount(multiProgramConfirm) || isMedOld}
							onClick={() => onBtnClick('Rejected')}
							className={status === 'Rejected' && !isMedOld ? classes.dialogBtnActionSelected : classes.dialogBtnAction}
							sx={status === 'Rejected' && !isMedOld ? {
								backgroundColor: 'var(--color-btn-selected-bg) !important',
								color: 'var(--color-btn-selected-text) !important',
								borderColor: 'var(--color-btn-selected-border) !important',
							} : undefined}
						>
							Reject
						</Button>
					</Grid>
					<Grid item>
						<FormControl className={classes.formControlStage}>
							<InputLabel id="med-reject-label" className={classes.stageLabel}
								sx={{ color: (status !== 'Rejected' || isMedOld) ? 'gray' : 'var(--color-primary-dark)' }}
							>
								Next action
							</InputLabel>
							<Select
								id="med-reject"
								labelId="med-reject-label"
								sx={{
									width: '6.8rem',
									paddingTop: '0px',
									fontSize: '0.7rem',
									'&:before, &:after, & .MuiOutlinedInput-notchedOutline': {
										border: 'none !important',
									},
								}}
								//	disabled={!checkStageCount(multiProgramConfirm)}
								disabled={status !== 'Rejected' || isMedOld}
								onChange={(e) => handleActionChange(e)}
								label="Next action"
								className={classes.nextActionSelect}
								inputProps={{
									classes: {
										icon: classes.icon,
										'aria-label': 'Next Action'
									},
								}}
							>
								{Object.keys(actionList)?.sort()?.map((item: any) =>
									<MenuItem key={item} value={item} className={classes.actionMenu}>
										{actionList[item]}
									</MenuItem>
								)}
							</Select>
						</FormControl>
					</Grid>
				</Grid>
			</Box >

			{approveOpen && (
				<ConfirmationDialogComponent
					open={approveOpen}
					content={`Evaluation is ${totalHr} hours old. Are you sure, you want to proceed?`}
					handleConfirmClose={handleConfirmClose}
					confirmStatus={confirmStatus}
				/>
			)
			}

		</>)
}

export default withStyles(stylesheet)(NextStageComponent)
